import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-513e98a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-steps__items" }
const _hoisted_2 = {
  class: "px-steps-item__circle",
  height: "24",
  viewbox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = {
  id: "a",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}
const _hoisted_4 = ["stop-color"]
const _hoisted_5 = ["stop-color"]
const _hoisted_6 = {
  fill: "none",
  "fill-rule": "nonzero"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  class: "px-steps-item__circle-outer",
  cx: "12",
  cy: "12",
  fill: "url(#a)",
  r: "8"
}, null, -1))
const _hoisted_8 = {
  key: 0,
  cx: "12",
  cy: "12",
  r: "11",
  stroke: "url(#a)"
}
const _hoisted_9 = {
  key: 1,
  height: "16",
  transform: "translate(4 4)",
  width: "16",
  "xlink:href": "/img/icons/check--white.svg"
}
const _hoisted_10 = { class: "px-steps-item__label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([`px-steps--${_ctx.theme}`, "px-steps"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: step.value,
          class: _normalizeClass([{
          'is-active': index === _ctx.active,
          'is-checked': index < _ctx.active,
        }, "px-steps-item"])
        }, [
          (_openBlock(), _createElementBlock("svg", _hoisted_2, [
            _createElementVNode("defs", null, [
              _createElementVNode("linearGradient", _hoisted_3, [
                _createElementVNode("stop", {
                  "stop-color": _ctx.firstGradientColor,
                  offset: "0%"
                }, null, 8, _hoisted_4),
                _createElementVNode("stop", {
                  "stop-color": _ctx.lastGradientColor,
                  offset: "100%"
                }, null, 8, _hoisted_5)
              ])
            ]),
            _createElementVNode("g", _hoisted_6, [
              _hoisted_7,
              (index === _ctx.active)
                ? (_openBlock(), _createElementBlock("circle", _hoisted_8))
                : _createCommentVNode("", true),
              (index < _ctx.active)
                ? (_openBlock(), _createElementBlock("image", _hoisted_9))
                : _createCommentVNode("", true)
            ])
          ])),
          _createElementVNode("span", _hoisted_10, _toDisplayString(step.label), 1)
        ], 2))
      }), 128))
    ])
  ], 2))
}